import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Button from '@component/form/element/button';
import I18n from '@module/i18n';

import Actions from '@app/store/action';

export function RejectButton({ onClick, rejectAll, context }) {
  const handleOnClick = () => {
    rejectAll(context);
    onClick && onClick();
  };

  return (
    <Button
      text={I18n.t('transfer.consent-manager.button-reject')}
      className="welcome__button welcome__button--decline"
      onClick={handleOnClick}
    />
  );
}

RejectButton.propTypes = {
  onClick: PropTypes.func,
  rejectAll: PropTypes.func.isRequired,
  context: PropTypes.string.isRequired,
};

export const mapDispatchToProps = (dispatch) => ({
  rejectAll: (context) => {
    dispatch(Actions.Consent.rejectAll(context));
  },
});

export default connect(null, mapDispatchToProps)(RejectButton);
